export const tr = {
    countries: 'todo',
    'desktop-view': 'Masaüstü',
    districts: 'todo',
    ltv: 'LTV',
    'mobile-view': 'Mobil cihazlar',
    'new-tab-view': 'todo',
    regions: 'todo'
};
